import type { FC } from 'react'
import React from 'react'
import type { CompanyFind } from '@pole-api/lib-integration-dadata-api/lib/models/CompanyFind'

const SuggestionCompany: FC<CompanyFind> = ({ value, data }) => {
  return <span>{`${value}, ИНН ${data?.inn}`}</span>
}

export default SuggestionCompany
